import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const EpilotSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default EpilotSVG;
